import { useState, useEffect, useCallback } from 'react';
import { VendorLookupItem } from '../types/costwand';
import { apiClient, ApiError } from '../api/apiClient.tsx';

interface UseVendorLookupResult {
  vendors: VendorLookupItem[];
  loading: boolean;
  error: string | null;
  fetchVendors: () => Promise<void>;
}

export const useVendorLookup = (): UseVendorLookupResult => {
  const [vendors, setVendors] = useState<VendorLookupItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchVendors = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      // Changed to use allPages: true and expect { data: T[] }
      const response = await apiClient<{ data: VendorLookupItem[] }>('/vendors', { allPages: true });
      setVendors(response.data);
    } catch (err) {
      if (err instanceof ApiError) {
        setError(`Failed to fetch vendors: ${err.message}`);
      } else {
        setError('An unknown error occurred while fetching vendors.');
      }
      setVendors([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchVendors();
  }, [fetchVendors]);

  return {
    vendors,
    loading,
    error,
    fetchVendors,
  };
};